<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',

}
</script>

<style>
.cursor {
  cursor: pointer;
}
.error-import-cell {
    background-color: #df132e;
}
</style>
